import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Popover from '@mui/material/Popover';
import Collapse from '@mui/material/Collapse';
import ListSubheader from '@mui/material/ListSubheader';

import InstagramIcon from '@mui/icons-material/Instagram';
import SignpostIcon from '@mui/icons-material/Signpost';
import WebIcon from '@mui/icons-material/Web';

import logo_01 from '../../data/images/ysLogo1.png';
import img_01 from '../../data/images/notice.png';

import { useNavigate } from 'react-router-dom';


interface Props {
    window?: () => Window;
    children?: any;
    };

    const HideOnScroll = (props: Props) => {
        const { children, window } = props;
        const trigger = useScrollTrigger({
            target: window ? window() : undefined,
            });
        
            return (
            <Slide appear={false} direction="down" in={!trigger}>
                {children}
            </Slide>
            );
        };

    const mainWidth = window.innerWidth;

/** 네비게이션바 */
const Navbar = (props: Props) => {


    const navigate = useNavigate();

    const drawerWidth = mainWidth;

    const newNav = ['Yonsei FC', 'Team', 'Program', 'Media', 'Community'];
    const newNav_kr = ['연세 소개', '팀 소개', '프로그램', '연세 소식', '커뮤니티'];

    const navMemberItems = ['Signup', 'login'];
    const navMemberItems_kr = ['회원가입', '로그인'];

    const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);

    const [hoveredItem, setHoveredItem] = useState(null);
    console.log("hover",hoveredItem);
    const handleItemHover = (item: any) => {
        setHoveredItem(item);
    };

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handleNavigate = (event: any) => {
        
        switch (event.target.innerText) {

            // Title: Yonsei FC
            case "센터 연혁":
                navigate('/history');
                break;

            case "조직도":
                navigate('/company');
                break;

            case "구장소개":
                navigate('/center');
                break;

            case "파트너십":
                navigate('/parters');
                break;
            
            // Title: Team
            case "유소년팀":
                navigate('/team');
                break;

            case "팀스태프":
                navigate('/staff');
                break;

            // Title: Team
            case "팀스케쥴":
                navigate('/teamProgram');
                break;

            case "프로그램 안내":
                navigate('/schedule');
                break;

            // Title: Media
            case "연세 소식":
                navigate('/news');
                break;

            case "연세 포토":
                navigate('/photo');
                break;

            case "연세 영상":
                navigate('/movie');
                break;

            // comunity
            case "공지사항":
                navigate('/notice');
                break;

            case "자주묻는 질문":
                navigate('/help');
                break;

            case "챗봇상담":
                navigate('/');
                break;

            // auth
            case "회원가입":
                navigate('/signup');
                break;
        
            case "로그인":
                navigate('/login');
                break;
            
            default:
                break;
        };
        handleClose();
    };

    const dropMenu: any = [
        {
            title: 'Yonsei FC',
            title_kr: '연세 소개',
            menu: ['센터 연혁', '조직도', '구장소개', '파트너십']
        },
        {
            title: 'Team',
            title_kr: '팀 소개',
            menu: ['유소년팀', '팀스태프']
        },
        {
            title: 'Program',
            title_kr: '프로그램',
            menu: ['팀스케쥴', '프로그램 안내']
        },
        {
            title: 'Media',
            title_kr: '연세 소식',
            menu: ['연세 소식', '연세 포토', '연세 영상']
        },
        {
            title: 'Community',
            title_kr: '커뮤니티',
            menu: ['공지사항', '자주묻는 질문', '챗봇 상담']
        }
    ];

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', width: '100%' }}>
            <Typography variant="h6" sx={{ my: 2 }}>
                <img src={logo_01} width={70} onClick={() => navigate('/')}/>
            </Typography>
            <Typography fontWeight={600} mb={3}>곤지암 연세 FC</Typography>
            <Divider />
            {newNav_kr.map((item, i) => (
                <List
                    subheader={
                        <ListSubheader 
                            component="div" 
                            id="nested-list-subheader" 
                            sx={{ 
                                textAlign: 'center', 
                                fontWeight: 600, 
                                fontSize: '1.2em',
                                backgroundColor: '#022656',
                                color: 'white',
                                }}>
                            {item}
                    </ListSubheader>
                    }
                >
                    {
                        dropMenu.map((el: any, i: any) => (
                            <>
                                {
                                    el.title_kr === item ?
                                    el.menu.map((el: any) => (
                                        <ListItem 
                                            key={item} 
                                            disablePadding 
                                            // onMouseEnter={() => handleItemHover(item)}
                                            // onMouseLeave={() => handleItemHover(null)}
                                            onClick={handleNavigate}
                                        >
                                            <ListItemButton sx={{ textAlign: 'center' }}>
                                                <ListItemText>
                                                    <Typography sx={{ fontWeight: 600, fontSize: '0.9em' }}>{el}</Typography>
                                                </ListItemText>
                                            </ListItemButton>
                                        </ListItem>
                                    ))
                                    :
                                    null
                                }
                            </>
                        ))
                    }
            </List>
        ))}
        </Box>
    );



    const container = window !== undefined ? () => window().document.body : undefined;

    // popover
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [ clickMenu, setClickMenu ] = React.useState(null);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setClickMenu(hoveredItem);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    console.log(anchorEl)
    return (
        <>
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <HideOnScroll {...props}>
            <AppBar
                position='fixed'
                component="nav" 
                sx={{ 
                    // backgroundImage: `url("${img_01}")`,
                    backgroundColor: 'white', 
                    color: 'black', 
                    p: 0.5,
                    boxShadow: 'rgba(0, 0, 0, 0.1) 1px 10px 30px',
                    // borderBottom: `10px solid #034296`,
                    // borderBottomRightRadius: '50px',
                    // borderTopRightRadius: '50px',
                    }}>
                <Toolbar 
                    sx={{ 
                        // border: '1px solid blue', 
                        width: '100%' 
                        }}>
                {/* 모바일 환경일 때 */}
                <Box 
                    sx={{ 
                        display: 'flex', 
                        '@media (max-width: 1300px)': {
                            // display: 'flex',
                            display: 'flex', 
                            justifyContent: 'space-between',
                            // border: '1px solid green',
                            minWidth: '100%'
                            // justifyContent: 'center' ,
                            // marginLeft: '25vw',
                        }
                        }}>
                    <Box
                        // component="div"
                        sx={{ 
                            display: { xs: 'flex', sm: 'block' }, 
                            // alignItems: 'center' ,
                            // marginLeft: 5,
                            // height: '100px',
                            // border: '1px solid yellow',
                            '@media (max-width: 1300px)': {
                                // display: 'flex',
                                // alignItems: 'center' ,
                                // border: '1px solid red',
                                // justifyContent: 'center' ,
                                // marginLeft: '25vw',
                            }
                        }}
                    >
                        {mainWidth > 1300 ?
                        <img src={logo_01} width={100} onClick={() => navigate('/')}/>
                        :
                        <>
                        <img src={logo_01} style={{ marginLeft: '1em'}} width={70} height={70} onClick={() => navigate('/')}/>
                        {/* <Typography fontSize={'1em'} fontWeight={600} sx={{ mt: 2.5, ml: 3 }}>Gonjiam Yonsei FC</Typography> */}
                        </>
                        }
                    </Box>
                        <Box sx={{ 
                                    // ml: -2, 
                                    display: { lg: 'none', xs: 'flex' },
                                }}>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                // edge="start"
                                onClick={handleDrawerToggle}
                                >
                            <MenuIcon />
                        </IconButton>
                        </Box>
                    </Box>
                {/* 모바일 환경일 때 */}
                {/* Nav Menu에 해당 */}

            <Box sx={{ ml: 0, display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                {/* Nav Menu Items Left */}
                <Box 
                    sx={{
                        ml: 10,
                        display: { xs: 'none', sm: 'none', lg: 'block'}
                        }}
                    >
                    {newNav.map((item, i) => (
                    <Button 
                        key={item} 
                        sx={{ 
                            width: '100px',
                            fontSize: '1em',
                            fontFamily: 'Roboto',
                            fontWeight: '600',
                            color: 'black',
                            // backgroundColor: 'white',
                            mr: 7,
                            }}
                        onMouseEnter={() => handleItemHover(item)}
                        onMouseLeave={() => handleItemHover(null)}
                        onClick={handleClick}
                        >
                        {hoveredItem === item ? newNav_kr.map((el, idx) => i === idx ? el : null) : item}
                    </Button>
                    ))}
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        sx={{
                            '.MuiPaper-root': {
                                width: '170px',
                                padding: 3,
                                marginTop: 4.5,
                                borderTopRightRadius: 0,
                                borderTopLeftRadius: 0,
                                borderBottomRightRadius: 8,
                                borderBottomLeftRadius: 8,
                                borderTop: `7px solid #034296`,
                                boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 20px',
                            },
                        }}
                    >
                        <Grid container spacing={0.5}>
                            {dropMenu.map((item: any, i: any) => (
                                <Grid item key={i} xs={12} lg={12}>
                                    {
                                        item.title === clickMenu ?
                                        <>
                                            <Typography mb={1} fontWeight={600} fontSize={'1.1em'} fontFamily={'Roboto'} textAlign={'center'}>
                                                {item.title_kr}
                                            </Typography>
                                            <Divider sx={{ mb: 2 }} />
                                        </>
                                        : null
                                    }
                                    {item.title === clickMenu
                                        ?
                                        item.menu.map((el: any) => (
                                            <Button
                                                fullWidth
                                                onClick={handleNavigate}
                                                sx={{
                                                    justifyContent: 'center',
                                                    color: 'black',
                                                    backgroundColor: 'white',
                                                    fontSize: '1em',
                                                    fontWeight: 600,
                                                    // fontFamily: 'Roboto',
                                                    '&:hover': {
                                                        backgroundColor: '#439dff',
                                                        color: 'white'
                                                    }
                                            }}
                                            >
                                                {el}
                                            </Button>
                                        ))
                                        : null
                                    }
                                </Grid>
                            ))}
                        </Grid>
                    </Popover>
                </Box>

                {/* Nav Menu Items Right */}
                    <Box
                        sx={{
                            ml: 7,
                            display: { xs: 'none', sm: 'none', lg: 'block'}
                        }}
                    >
                        {navMemberItems.map((item, i) => (
                            <Button
                            key={item} 
                                sx={{ 
                                    width: '100px',
                                    fontSize: '1em',
                                    fontFamily: 'Roboto',
                                    fontWeight: '600',
                                    color: 'black',
                                    // backgroundColor: 'white',
                                    mr: 2,
                                    }}
                            onMouseEnter={() => handleItemHover(item)}
                            onMouseLeave={() => handleItemHover(null)}
                            onClick={handleNavigate}
                            >
                                {hoveredItem === item ? navMemberItems_kr.map((el, idx) => i === idx ? el : null) : item}
                            </Button>
                        ))}
                        {/* <IconButton sx={{ border: '1px solid #dedede', p: 1 }}>
                            <MenuIcon />
                        </IconButton> */}
                    </Box>
                </Box>
            </Toolbar>
            </AppBar>
            </HideOnScroll>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        width: '100%',
                        display: { xs: 'block', sm: 'block' },
                        opacity: 1,
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                {drawer}
                </Drawer>
            </nav>
            </Box>
        </>
    )
}

export default Navbar